module.exports = __webpack_public_path__ + "img/facilityInfo_1_4.738d26c5.jpg";